import React, {useState} from 'react';
import CategoryCard from "./CategoryCard";
import {Row} from "react-bootstrap";
import useCategoryModal from "../../../hooks/useCategoryModal";
import {useDispatch} from "react-redux";
import {deleteCategory} from "../../../redux/slices/category";
import DeletePrompt from "./DeletePrompt";
import useToggle from "../../../shared/functions/useToggle";


export default function RenderList({data}) {
    
    const dispatch = useDispatch();

    const [toDelete, setToDelete] = useState(null);

    const {handleOpenWith, CategoryModal} = useCategoryModal();
    const {open, handleOpen, handleClose} = useToggle();

    const handleEdition = (id) => {
        handleOpenWith(data.find(one => one.id === id))
    }

    const handleDeletion = (id) => {
        setToDelete(id);
        handleOpen();
    }

    const handleConfirmDeletion = () => {
        dispatch(deleteCategory(toDelete))
    }

    return (
        <>
            <Row>
                {
                    data && data.map(item => (
                        <CategoryCard
                            {...item}
                            key={item.id}
                            onEdit={handleEdition}
                            onDelete={handleDeletion}
                        />
                    ))
                }
            </Row>

            <CategoryModal/>

            <DeletePrompt
                open={open}
                onClose={handleClose}
                onConfirm={handleConfirmDeletion}
            />

        </>
    );
}
